import * as Yup from "yup";
import {baseFieldsSchema} from "./baseFields";

export const schemaBase = Yup.object().shape({
    ...baseFieldsSchema
});